export class Registration {
  constructor(public List?: Item[]) {}
}

export interface Item {
  title?: string;
  description?: string;
  icon?: string;
  id?: string;
  link?: string;
  order?: number;
}
